import { Link, useRoute } from "wouter";

export function LinkTo({
	href,
	activeClassName = "active",
	className = "",
	children,
	handleClick,
	...rest
}) {
	const [isActive] = useRoute(href);

	return (
		<Link href={href} {...rest}>
			{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
			<a className={`${className} ${isActive ? activeClassName : ""}`}>
				{children}
			</a>
		</Link>
	);
}
